import type { TFunction } from 'i18next';

import yup from '../../../../shared/validation';

export function getCommunityInfoFormValidation(t: TFunction) {
  return yup.object({
    title: yup
      .string()
      .max(256, t('formikValidation.maxLength').replace('{0}', '256'))
      .required(t('formikValidation.firstnameRequired')),
    description: yup
      .string()
      .max(4096, t('formikValidation.maxLength').replace('{0}', '4096')),
  });
}
